import { Injectable } from '@angular/core';
import { Router, ResolveStart, ResolveEnd } from '@angular/router';
import { LoaderService } from 'ats-ui-lib';

@Injectable({
  providedIn: 'root',
})
export class NavigationLoaderService {
  constructor(
    private router: Router,
    private loader: LoaderService,
  ) {}

  public init(): void {
    this.router.events.subscribe((event) => {
      if (event instanceof ResolveStart) {
        this.loader.show();
      } else if (event instanceof ResolveEnd) {
        this.loader.hide();
      }
    });
  }
}
